import type { CommonStylesComponents, CommonStylesTheme } from '../types.d';

export const validationErrorsStyle = (components: CommonStylesComponents, theme: CommonStylesTheme) => ({
  '& ul[role=alert], & .font-error > ul': {
    listStyle: 'none',
    paddingLeft: 0,
  },

  '& span.is-error, & .font-error': {
    color: `${theme.semanticColors && theme.semanticColors.errorIcon}`,
  },
});
